import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TableCellDirective, TableColumnDirective, TableComponent, TableHeaderDirective } from '@libs/common/components';
import { ShoppingListModel } from '@libs/shop/models';
import { ShoppingListsState } from '@libs/shared/services';
import { LuxonDatePipe } from '@libs/shared/ui';
import { ShoppingListActionsComponent } from '../shopping-list-actions';

@Component({
  selector: 'ui-shopping-lists-desktop',
  templateUrl: './shopping-lists-desktop.component.html',
  styleUrls: ['./shopping-lists-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TableComponent,
    TableColumnDirective,
    TableHeaderDirective,
    TableCellDirective,
    ShoppingListActionsComponent,
    LuxonDatePipe,
  ],
})
export class ShoppingListsDesktopComponent {
  public shoppingListsService: ShoppingListsState = inject(ShoppingListsState);
  public shoppingLists: InputSignal<ShoppingListModel[]> = input.required();

  public showDetailsClicked(shoppingListId: string): void {
    void this.shoppingListsService.navigateToDetail(shoppingListId);
  }
}
